import { createSelector } from 'reselect';
import { sharedSelector } from './base-selector';

export const loaderVisibleSelector = createSelector(sharedSelector, state => state.loader.visible);
